<template>
  <div class="relative">
    <UInput
      v-model="searchTerm"
      :placeholder="
        $t('components.resources.destinations.searchDestination.placeholder')
      "
      size="xl"
      class="w-full tracking-wide"
      trailing-icon="mdi:magnify"
      @focus="showResults = true"
      @blur="showResults = false"
    />

    <div
      v-if="showResults && searchTerm && filteredDestinations.length > 0"
      class="absolute z-10 w-full mt-2 bg-white border border-gray-300 shadow-xl max-h-60 rounded-lg overflow-y-auto"
    >
      <ul class="py-1">
        <li
          v-for="destination in filteredDestinations"
          :key="destination.item.id"
          class="px-3 py-2 hover:bg-gray-100 cursor-pointer text-[1.2rem] tracking-wide duration-300 hover:pl-4"
          @mousedown="
            navigateTo(
              $localePath({
                name: 'destinations-slug',
                params: { slug: destination.item.slug },
              }),
            )
          "
        >
          <span
            v-html="
              hightlight(
                destination.item.name,
                destination.matches?.[0]?.indices,
              )
            "
          ></span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useFuse } from '@vueuse/integrations/useFuse'
import { computed, ref } from 'vue'

const { data: destinations, error: destinationsError } = await useFetch(
  '/api/destinations/search',
  {
    default: () => [],
  },
)
assertDefined(destinations, destinationsError)

const searchTerm = ref('')
const showResults = ref(false)

const options = computed(() => ({
  fuseOptions: {
    ignoreLocation: true,
    includeMatches: true,
    keys: ['name'],
    threshold: 0,
  },
  resultLimit: 20,
}))

function hightlight(text: string, matches: any) {
  return text
    .split('')
    .map((char, i) => {
      const isMatch = matches.some(
        ([start, end]: [number, number]) => i >= start && i <= end,
      )
      return isMatch ? `<strong class="font-bold">${char}</strong>` : char
    })
    .join('')
}

const { results: filteredDestinations } = useFuse(
  searchTerm,
  destinations,
  options,
)
</script>
